import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { get } from 'lodash';
import { push } from 'connected-react-router';
import { fetchUser, submitUserForm, resetPassword } from 'services/users/duck';
import { fetchList as fetchBrandList } from 'services/brands/duck';
import EditUserForm from 'components/organisms/forms/EditUser';

class EditUserFormContainer extends Component {
    componentDidMount() {
        const id = this.props.match.params.id;

        if (this.props.fetchUser && id) {
            this.props.fetchUser({ id });
        }

        this.props.fetchBrandList();
    }

    render() {
        const brandsWithSubDomains = this.props.brands.filter(brand => get(brand, 'meta.whitelabel.subdomain'));

        return (
            <EditUserForm
                user={this.props.user}
                resetPassword={this.props.resetPassword}
                entityList={this.props.entityList}
                brands={brandsWithSubDomains}
                dispatch={this.props.dispatch}
                handleSubmit={this.props.handleSubmit.bind(null, submitUserForm)}
                handleCancel={() => (this.props.push('/admin/users'))}
                selectedBrandId={this.props.selectedBrandId} >
                {this.props.children}
            </EditUserForm>
        );
    }
}

const form = 'editUser';
const formSelector = formValueSelector(form);

const mapStateToProps = state => ({
    user: state.users.user,
    initialValues: state.users.user,
    entityList: state.entities.list,
    brands: state.brands.list,
    selectedBrandId: formSelector(state, 'brandId')
});

export default compose(
    connect(mapStateToProps, { push, fetchUser, resetPassword, fetchBrandList }),
    reduxForm({
        form,
        enableReinitialize: true
    })
)(EditUserFormContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/users/EditUserContainer.js